
import { combineReducers } from "redux";
import FieldsReducer from "../FieldsReducer";
import LoginReducer from "../LoginReducer";
import { ModalPopupReducer } from "../ModalPopUpReducer";
import LoadingSpinnerReducer from "../LoadingSpinnerReducer";




 const Reducers = combineReducers({
    fieldreducer: FieldsReducer,
     loginreducer : LoginReducer,
     modalState : ModalPopupReducer,
     loadingSpinnerReducer : LoadingSpinnerReducer,
   



})

export default Reducers;